<script lang="ts">
    import HeightInput from "../components/HeightInput.svelte";
    import { DateInput } from 'date-picker-svelte';
	import { ssnvalidator,zipcodevalidator, phonenumbervalidator } from "../modules/validation"


    import { getContext } from "svelte";
    import { userState } from "../modules/store";
    import type { ApiService } from "../services";
    import type { Assessment } from "../services/assesment";
    import type { UserProcessNavigator } from "../modules/UserProcessNavigator";
import { now } from "svelte/internal";

    const api: ApiService = getContext("api-service");
    const nav: UserProcessNavigator = getContext("navigator");
    let assessment: Assessment = $userState.assessment;
    let assessmentDataForm:HTMLFormElement=null;

    const logevityQuintiles = [
        { value: 10, text: "Well Below Average" },
        { value: 30, text: "Below Average" },
        { value: 50, text: "About Average" },
        { value: 70, text: "Above Average" },
        { value: 90, text: "Well Above Average" },
    ];

    nav.navigateToDefaultForCurrentState();

    let formIsValid:boolean=true;
    function validate(){
        //const form:HTMLFormElement = document.forms["assessmentdata"];
        const form= assessmentDataForm;
        formIsValid=form.reportValidity() && (form.getElementsByClassName("field-validation-error").length===0);
        return formIsValid;
    }
    async function update(e): Promise<void> {
        if (validate()) {
            const updateResult = await api.UpdateAssessmentAsync(assessment);
            if (updateResult.success) {
                userState.update((s) => {
                    s.assessment = updateResult.data;
                    s.userDetailsConfirmed = true;
                    return s;
                });
                nav.next();
            } else {
                alert(updateResult.message);
            }
        }
    }
</script>

{#if assessment === null}
    <div>Assessment Not Found. Please contact the administrator.</div>
{:else}
    <div class="assessment-container">
        <div class="assessment-card">
            <fieldset class="fieldset">
                <h2 class="input-title">Confirm Your Personal Information</h2>
                {#if !formIsValid}
                    <span class="error_note">The information can not be submitted until the highlighted errors are resolved.</span>
                {/if}
                <form class="form" name="assessmentdata" on:change={validate} bind:this={assessmentDataForm}>
                    <div class="input-group">
                        <label for="firstName">First Name</label>
                        <input
                            class="assessment-input"
                            type="text"
                            name="firstName"
                            id="firstName"
                            required
                            bind:value={assessment.firstName}
                        />
                    </div>

                    <div class="input-group">
                        <label for="middleName">Middle Name</label>
                        <input
                            class="assessment-input"
                            type="text"
                            name="middleName"
                            id="middleName"
                            bind:value={assessment.middleName}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="lastName">Last Name</label>
                        <input
                            class="assessment-input"
                            type="text"
                            name="lastName"
                            id="lastName"
                            required
                            bind:value={assessment.lastName}
                        />
                    </div>
                    
                    <!-- New Gender selection field -->
                    <div class="input-group">
                        <label for="gender">Gender at Birth</label>
                        <div class="yesno">
                            <input
                                style="display:inline"
                                name="gender"
                                type="radio"
                                bind:group={assessment.gender}
                                value="M"
                                required
                            />Male (M)
                            <input
                                style="display:inline"
                                name="gender"
                                type="radio"
                                bind:group={assessment.gender}
                                value="F"
                                required
                            />Female (F)
                        </div>
                    </div>
                    
                    <div class="input-group">
                        <label for="dateOfBirth">Date of Birth</label>
                        <DateInput
                            class="custom-input"
                            format="MM-dd-yyyy"
                            min={new Date(1910,1,1)}
                            max={new Date(Date.now())}
                            placeholder="MM-DD-YYYY"
                            bind:value={assessment.dateOfBirth}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="ssn">Social Security Number</label>
                        <input
                            class="assessment-input"
                            type="text"
                            name="ssn"
                            id="ssn"
                            placeholder="XXX-XX-XXXX"
                            required
                            bind:value={assessment.govtId}
                            use:ssnvalidator={assessment.govtId}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="email">Email Address</label>
                        <input
                            class="assessment-input"
                            type="text"
                            name="email"
                            id="lastemailName"
                            readonly
                            value={assessment.email}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="homeAddressLine1">Home Address</label>
                        <input
                            class="assessment-input"
                            type="text"
                            name="homeAddressLine1"
                            id="homeAddressLine1"
                            required
                            bind:value={assessment.homeAddressLine1}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="homeCity">City</label>
                        <input
                            class="assessment-input"
                            type="text"
                            name="homeCity"
                            id="homeCity"
                            required
                            bind:value={assessment.homeCity}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="homeState">State</label>
                        <input
                            class="assessment-input"
                            type="text"
                            name="homeState"
                            id="homeState"
                            required
                            bind:value={assessment.homeStateOrProvince}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="homeZip">Zip Code</label>
                        <input
                            class="assessment-input"
                            type="text"
                            name="homeZip"
                            id="homeZip"
                            required
                            bind:value={assessment.homePostalCode}
                            use:zipcodevalidator={assessment.homePostalCode}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="homePhone">Home Phone</label>
                        <input
                            class="assessment-input"
                            type="tel"
                            name="homePhone"
                            id="homePhone"
                            required
                            bind:value={assessment.homePhone}
                            use:phonenumbervalidator={assessment.homePhone}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="mobilePhone">Mobile Phone</label>
                        <input
                            class="assessment-input"
                            type="tel"
                            name="mobilePhone"
                            id="mobilePhone"
                            bind:value={assessment.mobilePhone}
                            use:phonenumbervalidator={assessment.mobilePhone}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="workPhone">Work Phone</label>
                        <input
                            class="assessment-input"
                            type="tel"
                            name="workPhone"
                            id="workPhone"
                            bind:value={assessment.workPhone}
                            use:phonenumbervalidator={assessment.workPhone}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="height">Height</label>
                        <HeightInput bind:value={assessment.height} />
                    </div>
                    
                    <div class="input-group">
                        <label for="weight">Weight (lbs)</label>
                        <input
                            class="assessment-input"
                            type="number"
                            name="weight"
                            id="weight"
                            min="65"
                            max="700"
                            required
                            bind:value={assessment.weight}
                        />
                    </div>
                    
                    <div class="input-group">
                        <label for="smoker">Do you use any tobacco<br />or nicotine products?</label>
                        <div class="yesno">
                            <input
                                style="display:inline"
                                name="smoker_yes"
                                type="radio"
                                bind:group={assessment.riskClass}
                                value="SM"
                            />Yes
                            <input
                                style="display:inline"
                                name="smoker_no"
                                type="radio"
                                bind:group={assessment.riskClass}
                                value="NS"
                            />No
                        </div>
                    </div>
                    
                    <div class="input-group">
                        <label for="expectedRank">Where do you think <br />your longevity will rank?</label>
                        <select
                            id="expectedRank"
                            name="expectedRank"
                            bind:value={assessment.expectedLongevityRank}
                        >
                            {#each logevityQuintiles as q (q.value)}
                                <option value={q.value}>{q.text}</option>
                            {/each}
                        </select>
                    </div>
                    
                    <div class="input-group">
                        <label for="desiredLongevityRank">Where do you want <br />your longevity to rank?</label>
                        <select
                            id="desiredLongevityRank"
                            name="desiredLongevityRank"
                            bind:value={assessment.desiredLongevityRank}
                        >
                            {#each logevityQuintiles as q (q.value)}
                                <option value={q.value}>{q.text}</option>
                            {/each}
                        </select>
                    </div>
                </form>
            </fieldset>
            
            <button class="submit-button" on:click={update} disabled={!formIsValid}>
                Yes, my information is correct
            </button>
            
            {#if !formIsValid}
                <span class="error_note">The information can not be submitted until the highlighted errors are resolved.</span>
            {/if}
        </div>
    </div>
{/if}

<style>
.assessment-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 20px;
}

.assessment-card {
    background: white;
    padding: 40px 48px;
    border-radius: 20px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.07);
    width: 100%;
    max-width: 650px;
    text-align: center;
}

.assessment-title {
    color: #2c3e50;
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 30px;
    text-align: center;
}

.input-group {
    margin-bottom: 28px;
    text-align: left;
}

.input-group label {
    display: block;
    font-weight: 600;
    font-size: 1.08rem;
    margin-bottom: 8px;
    color: #2c3e50;
}

.assessment-input, select {
    width: 100%;
    padding: 16px 20px;
    border: 2px solid #e9ecef;
    border-radius: 12px;
    font-size: 1rem;
    transition: all 0.3s ease;
    background: #f8f9fa;
    color: #2c3e50;
    box-sizing: border-box;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
}

.assessment-input:focus, select:focus {
    outline: none;
    border-color: #ffd966;
    background: white;
    box-shadow: 0 0 0 3px rgba(255, 217, 102, 0.1);
}

select {
    background-image: url('data:image/svg+xml;utf8,<svg fill="%232c3e50" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
    background-repeat: no-repeat;
    background-position: right 16px center;
    background-size: 20px 20px;
    cursor: pointer;
}

.assessment-input::placeholder {
    color: #6c757d;
}

/* Custom radio buttons */
.yesno {
    display: flex;
    gap: 32px;
    align-items: center;
    margin-top: 4px;
}
.yesno label {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
    margin-right: 16px;
}
.yesno input[type="radio"] {
    appearance: none;
    -webkit-appearance: none;
    background-color: #fff;
    border: 2px solid #ffd966;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    margin-right: 8px;
    position: relative;
    transition: border-color 0.2s;
    cursor: pointer;
}
.yesno input[type="radio"]:checked {
    border-color: #ffd966;
    background-color: #ffd966;
}
.yesno input[type="radio"]:checked::after {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    background: #2c3e50;
    border-radius: 50%;
    position: absolute;
    top: 5px;
    left: 5px;
}
.yesno input[type="radio"]:focus {
    outline: 2px solid #ffd966;
}

.submit-button {
    display: inline-block;
    background: #ffd966;
    color: #2c3e50;
    padding: 16px 40px;
    border-radius: 30px;
    font-size: 1.2rem;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(255, 217, 102, 0.3);
    border: none;
    cursor: pointer;
    width: 100%;
    margin-bottom: 15px;
}

.submit-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 217, 102, 0.4);
    background: #ffe066;
}

.submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.submit-button.hidden {
    display: none;
}

.error_note {
    color: #dc3545;
    font-size: 0.98rem;
    margin-top: 10px;
    display: block;
    text-align: left;
}

.custom-input {
    width: 100%;
    padding: 16px 20px;
    border: 2px solid #e9ecef;
    border-radius: 12px;
    font-size: 1rem;
    transition: all 0.3s ease;
    background: #f8f9fa;
    color: #2c3e50;
    box-sizing: border-box;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
}
.custom-input:focus {
    outline: none;
    border-color: #ffd966;
    background: white;
    box-shadow: 0 0 0 3px rgba(255, 217, 102, 0.1);
}

@media (max-width: 900px) {
    .assessment-card {
        max-width: 98vw;
        padding: 24px 6vw;
    }
}
@media (max-width: 600px) {
    .assessment-container {
        padding: 6px;
    }
    .assessment-card {
        padding: 18px 2vw;
        max-width: 100vw;
    }
    .assessment-title {
        font-size: 1.3rem;
    }
    .submit-button {
        font-size: 1rem;
        padding: 12px 10px;
    }
    .input-group label {
        font-size: 1rem;
    }
    .custom-input {
        font-size: 1rem;
        padding: 12px 10px;
    }
}
</style>
